import ContextDataSource from './context-datasource'
import MicroflowDataSource from './microflow-datasource'
import ObjectModelDataSource from './objectModel-datasource'

const datasources = {
  ContextDataSource: () => Promise.resolve({ default: ContextDataSource }),
  MicroflowDataSource: () => Promise.resolve({ default: MicroflowDataSource }),
  ObjectModelDataSource: () => Promise.resolve({ default: ObjectModelDataSource })
}

export default datasources
